// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type UsersPageQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type UsersPageQuery = { __typename?: 'Query', internalUsers: Array<{ __typename?: 'InternalUser', id: string, name: string, avatar: string, email: string, user: { __typename?: 'User', id: string, isActive: boolean } }> };

export type ActivateUsersMutationVariables = Types.Exact<{
  input: Types.ActivateUsersInput;
}>;


export type ActivateUsersMutation = { __typename?: 'Mutation', activateUsers: { __typename?: 'ActivateUsersResult', users: Array<{ __typename?: 'User', id: string }> } };

export type DeactivateUsersMutationVariables = Types.Exact<{
  input: Types.DeactivateUsersInput;
}>;


export type DeactivateUsersMutation = { __typename?: 'Mutation', deactivateUsers: { __typename?: 'DeactivateUsersResult', users: Array<{ __typename?: 'User', id: string }> } };


export const UsersPageDocument = gql`
    query UsersPage {
  internalUsers(filter: {includeDeactivated: true}) {
    id
    name
    avatar
    email
    user {
      id
      isActive
    }
  }
}
    `;

/**
 * __useUsersPageQuery__
 *
 * To run a query within a React component, call `useUsersPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useUsersPageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UsersPageQuery, UsersPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UsersPageQuery, UsersPageQueryVariables>(UsersPageDocument, options);
      }
export function useUsersPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UsersPageQuery, UsersPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UsersPageQuery, UsersPageQueryVariables>(UsersPageDocument, options);
        }
// @ts-ignore
export function useUsersPageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UsersPageQuery, UsersPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UsersPageQuery, UsersPageQueryVariables>;
export function useUsersPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UsersPageQuery, UsersPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UsersPageQuery | undefined, UsersPageQueryVariables>;
export function useUsersPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UsersPageQuery, UsersPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UsersPageQuery, UsersPageQueryVariables>(UsersPageDocument, options);
        }
export type UsersPageQueryHookResult = ReturnType<typeof useUsersPageQuery>;
export type UsersPageLazyQueryHookResult = ReturnType<typeof useUsersPageLazyQuery>;
export type UsersPageSuspenseQueryHookResult = ReturnType<typeof useUsersPageSuspenseQuery>;
export type UsersPageQueryResult = Apollo.QueryResult<UsersPageQuery, UsersPageQueryVariables>;
export const ActivateUsersDocument = gql`
    mutation ActivateUsers($input: ActivateUsersInput!) {
  activateUsers(input: $input) {
    users {
      id
    }
  }
}
    `;
export type ActivateUsersMutationFn = Apollo.MutationFunction<ActivateUsersMutation, ActivateUsersMutationVariables>;

/**
 * __useActivateUsersMutation__
 *
 * To run a mutation, you first call `useActivateUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateUsersMutation, { data, loading, error }] = useActivateUsersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useActivateUsersMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ActivateUsersMutation, ActivateUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ActivateUsersMutation, ActivateUsersMutationVariables>(ActivateUsersDocument, options);
      }
export type ActivateUsersMutationHookResult = ReturnType<typeof useActivateUsersMutation>;
export type ActivateUsersMutationResult = Apollo.MutationResult<ActivateUsersMutation>;
export type ActivateUsersMutationOptions = Apollo.BaseMutationOptions<ActivateUsersMutation, ActivateUsersMutationVariables>;
export const DeactivateUsersDocument = gql`
    mutation DeactivateUsers($input: DeactivateUsersInput!) {
  deactivateUsers(input: $input) {
    users {
      id
    }
  }
}
    `;
export type DeactivateUsersMutationFn = Apollo.MutationFunction<DeactivateUsersMutation, DeactivateUsersMutationVariables>;

/**
 * __useDeactivateUsersMutation__
 *
 * To run a mutation, you first call `useDeactivateUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateUsersMutation, { data, loading, error }] = useDeactivateUsersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeactivateUsersMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeactivateUsersMutation, DeactivateUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeactivateUsersMutation, DeactivateUsersMutationVariables>(DeactivateUsersDocument, options);
      }
export type DeactivateUsersMutationHookResult = ReturnType<typeof useDeactivateUsersMutation>;
export type DeactivateUsersMutationResult = Apollo.MutationResult<DeactivateUsersMutation>;
export type DeactivateUsersMutationOptions = Apollo.BaseMutationOptions<DeactivateUsersMutation, DeactivateUsersMutationVariables>;